import TextLateral from './TextLateral';

export default TextLateral;
